import { Typography } from '@material-ui/core';
import React from 'react';
import {
  DashboardAttribution,
  DashboardExport,
  DashboardFilter,
  DashboardMetadata,
  DashboardMetrics,
  DashboardMultipleConnections,
  DashboardReports,
  DashboardTeams,
  DashboardTimeline,
  FeatureGrid
} from '../../components/FeatureGrid';
import { Headline } from '../../components/Headline';
import PageHead from '../../components/PageHead';
import Section, { Label } from '../../components/Section';
import { SEO } from '../../components/SEO';
import { SignupButtonWithChoice } from '../../components/SignupButton';
import MainLayout from '../../layouts/main';

export default () => {
  return (
    <MainLayout>
      <div>
        <SEO
          pathname="/product/unify/"
          title="Affilimate Unify: Unified Affiliate Data for Publishers"
          description="Aggregate affiliate data from 100+ networks into one trusted source: transactions, rates, finance data, and payouts that your team, the Affilimate Agent, and your MCP-connected AI tools can all query. No code required."
        />
        <PageHead>
          <Headline
            variant="h3"
            gutterBottom
            component="h2"
            style={{
              maxWidth: '730px',
              margin: '0 auto 36px',
              fontWeight: 900
            }}
          >
            Unify for Publishers
          </Headline>
          <Headline
            variant="h1"
            gutterBottom
            component="h1"
            style={{
              maxWidth: '750px',
              margin: '0 auto 36px',
              fontWeight: 900
            }}
          >
            Unified affiliate data, dashboards, and APIs for publishers of all
            stripes
          </Headline>
          <Typography
            variant="body1"
            color="textSecondary"
            style={{ maxWidth: '560px', margin: '24px auto 12px' }}
          >
            Aggregate and unify all your affiliate data from 100+ networks into
            one place: transactions, rates, finance data, and payouts. Set up
            without a developer, then query it all from the Affilimate Agent or
            your own AI tools via MCP. No code required.
          </Typography>
          <img
            src="/images/features/dashboard-integrations-top.png"
            style={{
              width: '80%',
              maxWidth: '700px',
              margin: '0 auto',
              display: 'block'
            }}
            alt="Affiliate dashboard"
          />
          <div style={{ textAlign: 'center', margin: '48px auto 0' }}>
            <SignupButtonWithChoice text="Get started" />
          </div>
        </PageHead>
        <Section
          image="/images/features/affiliate-dashboard/integration-setup.png"
          variant="screenshot"
          orientation="right"
          headline={
            <>
              <Label>Integrations</Label>
              <Typography variant="h5" component="h3" gutterBottom>
                Integrate with 100+ affiliate networks, platforms, and programs
              </Typography>
            </>
          }
          body={
            <>
              <Typography paragraph variant="body1">
                Monitor your commissions and run cross-cutting reports on
                affiliate earnings from over one hundred different platforms.
              </Typography>

              <Typography paragraph variant="body1">
                All major networks, aggregators, and SaaS software solutions
                included.
              </Typography>

              <Typography paragraph variant="body1">
                Set up in minutes without a developer.
              </Typography>
            </>
          }
        />
        <Section
          image="/images/features/affiliate-dashboard/dashboard-view.png"
          variant="screenshot"
          orientation="right"
          headline={
            <>
              <Label>Unified dashboard</Label>
              <Typography variant="h5" component="h3" gutterBottom>
                All your affiliate commissions in one place
              </Typography>
            </>
          }
          body={
            <>
              <Typography paragraph variant="body1">
                Transaction reports show you your latest conversions, and which
                page and link the conversion happened on.
              </Typography>
              <Typography paragraph variant="body1">
                Stop asking yourself what's working start crafting a
                data-informed affiliate strategy.
              </Typography>
            </>
          }
        />
        <Section
          image="/images/features/affiliate-dashboard/transaction-details.png"
          variant="screenshot"
          orientation="right"
          headline={
            <>
              <Label>SKU Reporting</Label>
              <Typography variant="h5" component="h3" gutterBottom>
                Click any transaction to reveal product details and metadata
              </Typography>
            </>
          }
          body={
            <Typography paragraph variant="body1">
              Uncover the data points buried inside your affiliate reports that
              tell you which products your audience actually wants to buy.
            </Typography>
          }
        />
        <Section
          image="/images/features/dashboard-integrations-top.png"
          variant="screenshot"
          orientation="right"
          headline={
            <>
              <Label>Agent &amp; MCP · Early access</Label>
              <Typography variant="h5" component="h3" gutterBottom>
                Ask your data questions instead of building reports
              </Typography>
            </>
          }
          body={
            <>
              <Typography paragraph variant="body1">
                Unified data is what makes the AI platform useful. Ask the
                Affilimate Agent why revenue moved, or connect Claude, ChatGPT,
                and other tools to your workspace through the Affilimate MCP.
              </Typography>
              <Typography paragraph variant="body1">
                Your transaction, finance, and rates data, accessible from a
                chat window, with no code and no exports.
              </Typography>
            </>
          }
        />
        <div style={{ textAlign: 'center', margin: '48px auto 96px' }}>
          <SignupButtonWithChoice text="Get started" />
        </div>
        <div style={{ maxWidth: '900px', margin: '96px auto 48px' }}>
          <Typography
            variant="h4"
            gutterBottom
            component="h2"
            style={{
              textAlign: 'center',
              fontWeight: 900
            }}
          >
            But wait, there's more
          </Typography>
          <Typography
            variant="body1"
            component="p"
            style={{
              maxWidth: '510px',
              margin: '0 auto',
              textAlign: 'center'
            }}
          >
            Combine a simple interface with powerful features like these
          </Typography>
        </div>
        <FeatureGrid>
          <DashboardMetrics />
          <DashboardReports />
          <DashboardMultipleConnections />
          <DashboardMetadata />
          <DashboardFilter />
          <DashboardExport />
          <DashboardTimeline />
          <DashboardAttribution />
          <DashboardTeams />
        </FeatureGrid>
        <div style={{ textAlign: 'center', margin: '48px auto 96px' }}>
          <img
            src="/images/features/dashboard-integrations-top.png"
            style={{
              width: '80%',
              maxWidth: '450px',
              margin: '0 auto 24px',
              display: 'block'
            }}
            alt="Affiliate dashboard"
          />
          <SignupButtonWithChoice text="Get started" />
        </div>
      </div>
    </MainLayout>
  );
};
